export default {
  "b2b.produkt-editace-form.field.nazevCs.label": "Name CS",
  "b2b.produkt-editace-form.field.nazevEn.label": "Name EN",
  "b2b.produkt-editace-form.field.popisCs.label": "Description CS",
  "b2b.produkt-editace-form.field.popisEn.label": "Description EN",
  "b2b.produkt-editace-form.field.zkratka.label": "Abbreviation",
  "b2b.produkt-editace-form.field.uzivaNapajeni.label": "It uses power",
  "b2b.produkt-editace-form.field.vylucny.label": "Exclusive",
  "b2b.produkt-editace-form.field.parkovani.label": "Parking",
  "b2b.produkt-editace-form.field.bezCasu.label": "Timeless",
  "b2b.produkt-editace-form.field.platnostOd.label": "Valid from",
  "b2b.produkt-editace-form.button.delete": "Delete",
  "b2b.produkt-editace-form.button.submit": "Save",
  "b2b.produkt-editace-form.button.cancel": "Cancel",
  "b2b.produkt-editace-widget.titleNew": "New product",
  "b2b.produkt-editace-form.save-dialog.title": "Save product",
  "b2b.produkt-editace-form.delete-dialog.title": "Delete product"
};
